/* tslint:disable */
/* eslint-disable */
/**
 * Tumelo API
 * This is Tumelo\'s API. It drives increased shareholder engagement by providing transparency of the organizations owned by investors and giving them a voice by allowing them to vote on important issues at these organizations.  The main uses of this API are:  * Transparency - To provide a breakdown to an investor of the organizations in which they are invested. * Voting - To provide the ability for an investor to vote on a poll concerning organizations in which they are invested.  ## Status  This API is currently available as a closed **BETA**. We invite interested parties to [give us feedback](mailto:support@tumelo.com) on this API, its documentation, or anything else about Tumelo\'s transparency service prior to the API becoming generally available.  ## Changelog  A changelog for the api can be found [here](CHANGELOG.md).  ## Access The API is available at the following URL: ``` https://api.prod.tumelo.com/v1 ```  For information on how to obtain access to the API, please [contact us](mailto:support@tumelo.com).  ## Development vs Production Habitats Development and Production environments are separated into their own habitats. Please [contact us](mailto:support@tumelo.com) when you\'re ready to go into production and require access to your company\'s live habitat.  # Using the API  ## Case Sensitivity URLs, headers, path parameters, query parameter names, and query parameter values are all case sensitive. Be careful to use the correct case when constructing requests.  ## Error Handling Requests may return an error indicating that there was a problem responding. The response will contain an HTTP status code as well as a JSON object in the following format which describes the error in more detail: ```json {   \"message\": \"Resource not found\" } ```  ## Pagination Requests that return lists and describe pagination parameters support paginated results. Results are separated into multiple pages, where the size of each page is determined by the `pageSize` query parameter. If omitted, `pageSize` defaults to 50 records. When a response includes a `nextPageToken` in the response body, this token value should be passed as a query parameter `nextPageToken` to the same endpoint in order to retrieve the next page of results. This process should be repeated until the response doesn’t include a `nextPageToken`, indicating that the end of the results has been reached.  When passing the `nextPageToken` parameter, all other filter and query parameters present in the previous request, **must** be filled. Filter parameters *must not* be changed while paginating since this will result in an error or an incorrect overall list. The `nextPageToken` will not be present in the response body if the end of the list has been reached and no further results are available.  ## String Formats The following string formats are used throughout this API.  ### date-time The valid format is date-time notation as defined by [RFC 3339, section 5.6](https://tools.ietf.org/html/rfc3339#section-5.6).  For example: `2020-11-30T10:45:28Z`  # Support If you have any technical questions relating to the Tumelo API, please [contact us](mailto:support@tumelo.com), explaining your question or issue in as much detail as possible, including the operation you were performing and the ISIN or Organization ID you were querying, as well as the results you expected and the actual results or error message you observed. You can expect a response within one business day.  ## Data Issues During development and testing in your development habitat we make available a test data set that includes some sample data constructed to illustrate functionality. It is not intended to be used for any purpose other than testing and/or demonstrating functionality, and should not be relied upon to be an accurate reflection of the underlying holdings of any real fund.  If you have any questions or concerns about the data accuracy or completeness of the data in the production environment, please [report the matter](mailto:support@tumelo.com) to us, giving as much information as possible about the issue.  # Compositions and Breakdowns  An instrument may have a composition, this means it is a fund invested in other instruments.  A breakdown is the bottom level components of a composite instrument or account. By this, we mean organizations and cash that a particular composite instrument or account is invested into either directly or through funds.  Breakdowns also have an `other` listing, this is for funds that only have partial information available, or where an instrument is not mapped to an organization. 
 *
 * The version of the OpenAPI document: 0.145.1
 * Contact: support@tumelo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ListModelPortfolioCompositionsResponse,
  ListModelPortfoliosResponse,
  ModelPortfolio,
  ModelPortfolioComposition2,
  OrganizationBreakdown,
} from '../models';
import {
    ListModelPortfolioCompositionsResponseFromJSON,
    ListModelPortfolioCompositionsResponseToJSON,
    ListModelPortfoliosResponseFromJSON,
    ListModelPortfoliosResponseToJSON,
    ModelPortfolioFromJSON,
    ModelPortfolioToJSON,
    ModelPortfolioComposition2FromJSON,
    ModelPortfolioComposition2ToJSON,
    OrganizationBreakdownFromJSON,
    OrganizationBreakdownToJSON,
} from '../models';

export interface CreateModelPortfolioRequest {
    habitatId: string;
    modelPortfolio?: ModelPortfolio;
}

export interface CreateModelPortfolioCompositionRequest {
    habitatId: string;
    modelPortfolioId: string;
    modelPortfolioComposition2: ModelPortfolioComposition2;
}

export interface GetModelPortfolioEquityBreakdownRequest {
    habitatId: string;
    modelPortfolioId: string;
    newBreakdown?: boolean;
}

export interface GetOrganizationBreakdownByModelPortfolioRequest {
    habitatId: string;
    modelPortfolioId: string;
    newBreakdown?: boolean;
}

export interface ListModelPortfolioCompositionsRequest {
    habitatId: string;
    modelPortfolioId: string;
    pageSize?: number;
    nextPageToken?: string;
}

export interface ListModelPortfoliosRequest {
    habitatId: string;
    pageSize?: number;
    nextPageToken?: string;
}

/**
 * ModelPortfoliosApi - interface
 * 
 * @export
 * @interface ModelPortfoliosApiInterface
 */
export interface ModelPortfoliosApiInterface {
    /**
     * Creates a model portfolio associated to the habitat
     * @summary Create model portfolio
     * @param {string} habitatId The habitat identifier.
     * @param {ModelPortfolio} [modelPortfolio] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModelPortfoliosApiInterface
     */
    createModelPortfolioRaw(requestParameters: CreateModelPortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ModelPortfolio>>;

    /**
     * Creates a model portfolio associated to the habitat
     * Create model portfolio
     */
    createModelPortfolio(requestParameters: CreateModelPortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ModelPortfolio>;

    /**
     * Create a model portfolio composition.
     * @summary Create model portfolio composition
     * @param {string} habitatId The habitat identifier.
     * @param {string} modelPortfolioId The model portfolio identifier.
     * @param {ModelPortfolioComposition2} modelPortfolioComposition2 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModelPortfoliosApiInterface
     */
    createModelPortfolioCompositionRaw(requestParameters: CreateModelPortfolioCompositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ModelPortfolioComposition2>>;

    /**
     * Create a model portfolio composition.
     * Create model portfolio composition
     */
    createModelPortfolioComposition(requestParameters: CreateModelPortfolioCompositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ModelPortfolioComposition2>;

    /**
     * Returns the breakdown of the model portfolio in terms of the organizations that issued the underlying shares. The top level \'readTime\' represents the time this computation was made, the \'validAt\'s within the \'basedOn\' section represent the valid time for the compositions of the isins they\'re paired with. The endpoint will return a `400 Bad Request` error when the equity breakdown cannot be computed due to either the model portfolio having no composition or the latest composition being empty. 
     * @summary Get equity breakdown for a model portfolio that only includes instruments with a MIFIR code of \"SHRS\"
     * @param {string} habitatId The habitat identifier.
     * @param {string} modelPortfolioId The id of the model portfolio.
     * @param {boolean} [newBreakdown] Passing a newBreakdown parameter with value &#x60;true&#x60; will compute the breakdown using the fund model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModelPortfoliosApiInterface
     */
    getModelPortfolioEquityBreakdownRaw(requestParameters: GetModelPortfolioEquityBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationBreakdown>>;

    /**
     * Returns the breakdown of the model portfolio in terms of the organizations that issued the underlying shares. The top level \'readTime\' represents the time this computation was made, the \'validAt\'s within the \'basedOn\' section represent the valid time for the compositions of the isins they\'re paired with. The endpoint will return a `400 Bad Request` error when the equity breakdown cannot be computed due to either the model portfolio having no composition or the latest composition being empty. 
     * Get equity breakdown for a model portfolio that only includes instruments with a MIFIR code of \"SHRS\"
     */
    getModelPortfolioEquityBreakdown(requestParameters: GetModelPortfolioEquityBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationBreakdown>;

    /**
     * Returns the breakdown of the model portfolio in terms of the organizations that issued the underlying stocks, shares and bonds. The top level \'readTime\' represents the time this computation was made, the \'validAt\'s within the \'basedOn\' section represent the valid time for the compositions of the isins they\'re paired with.
     * @summary Get organization breakdown for a model portfolio
     * @param {string} habitatId The habitat identifier.
     * @param {string} modelPortfolioId The model portfolio identifier.
     * @param {boolean} [newBreakdown] Passing a newBreakdown parameter with value &#x60;true&#x60; will compute the breakdown using the fund model.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModelPortfoliosApiInterface
     */
    getOrganizationBreakdownByModelPortfolioRaw(requestParameters: GetOrganizationBreakdownByModelPortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationBreakdown>>;

    /**
     * Returns the breakdown of the model portfolio in terms of the organizations that issued the underlying stocks, shares and bonds. The top level \'readTime\' represents the time this computation was made, the \'validAt\'s within the \'basedOn\' section represent the valid time for the compositions of the isins they\'re paired with.
     * Get organization breakdown for a model portfolio
     */
    getOrganizationBreakdownByModelPortfolio(requestParameters: GetOrganizationBreakdownByModelPortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationBreakdown>;

    /**
     * List all model portfolio compositions in chronological order. The composition with the latest `validAt` time is listed first. For compositions with the same `validAt` times, the one with the latest `createdAt` time is listed first. Without any pagination parameters, a maximum of 50 compositions will be returned.
     * @summary List model portfolio compositions
     * @param {string} habitatId The habitat identifier.
     * @param {string} modelPortfolioId The model portfolio identifier.
     * @param {number} [pageSize] The maximum number of elements to return.
     * @param {string} [nextPageToken] Passing a nextPageToken will cause the next page of results to be retrieved.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModelPortfoliosApiInterface
     */
    listModelPortfolioCompositionsRaw(requestParameters: ListModelPortfolioCompositionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListModelPortfolioCompositionsResponse>>;

    /**
     * List all model portfolio compositions in chronological order. The composition with the latest `validAt` time is listed first. For compositions with the same `validAt` times, the one with the latest `createdAt` time is listed first. Without any pagination parameters, a maximum of 50 compositions will be returned.
     * List model portfolio compositions
     */
    listModelPortfolioCompositions(requestParameters: ListModelPortfolioCompositionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListModelPortfolioCompositionsResponse>;

    /**
     * Returns the model portfolios that are associated with this habitat.
     * @summary List model portfolios
     * @param {string} habitatId The habitat identifier.
     * @param {number} [pageSize] The maximum number of elements to return.
     * @param {string} [nextPageToken] Passing a nextPageToken will cause the next page of results to be retrieved.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModelPortfoliosApiInterface
     */
    listModelPortfoliosRaw(requestParameters: ListModelPortfoliosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListModelPortfoliosResponse>>;

    /**
     * Returns the model portfolios that are associated with this habitat.
     * List model portfolios
     */
    listModelPortfolios(requestParameters: ListModelPortfoliosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListModelPortfoliosResponse>;

}

/**
 * 
 */
export class ModelPortfoliosApi extends runtime.BaseAPI implements ModelPortfoliosApiInterface {

    /**
     * Creates a model portfolio associated to the habitat
     * Create model portfolio
     */
    async createModelPortfolioRaw(requestParameters: CreateModelPortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ModelPortfolio>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling createModelPortfolio.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/habitats/{habitatId}/modelPortfolios`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ModelPortfolioToJSON(requestParameters.modelPortfolio),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ModelPortfolioFromJSON(jsonValue));
    }

    /**
     * Creates a model portfolio associated to the habitat
     * Create model portfolio
     */
    async createModelPortfolio(requestParameters: CreateModelPortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ModelPortfolio> {
        const response = await this.createModelPortfolioRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a model portfolio composition.
     * Create model portfolio composition
     */
    async createModelPortfolioCompositionRaw(requestParameters: CreateModelPortfolioCompositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ModelPortfolioComposition2>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling createModelPortfolioComposition.');
        }

        if (requestParameters.modelPortfolioId === null || requestParameters.modelPortfolioId === undefined) {
            throw new runtime.RequiredError('modelPortfolioId','Required parameter requestParameters.modelPortfolioId was null or undefined when calling createModelPortfolioComposition.');
        }

        if (requestParameters.modelPortfolioComposition2 === null || requestParameters.modelPortfolioComposition2 === undefined) {
            throw new runtime.RequiredError('modelPortfolioComposition2','Required parameter requestParameters.modelPortfolioComposition2 was null or undefined when calling createModelPortfolioComposition.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/habitats/{habitatId}/modelPortfolios/{modelPortfolioId}/compositions`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))).replace(`{${"modelPortfolioId"}}`, encodeURIComponent(String(requestParameters.modelPortfolioId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ModelPortfolioComposition2ToJSON(requestParameters.modelPortfolioComposition2),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ModelPortfolioComposition2FromJSON(jsonValue));
    }

    /**
     * Create a model portfolio composition.
     * Create model portfolio composition
     */
    async createModelPortfolioComposition(requestParameters: CreateModelPortfolioCompositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ModelPortfolioComposition2> {
        const response = await this.createModelPortfolioCompositionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the breakdown of the model portfolio in terms of the organizations that issued the underlying shares. The top level \'readTime\' represents the time this computation was made, the \'validAt\'s within the \'basedOn\' section represent the valid time for the compositions of the isins they\'re paired with. The endpoint will return a `400 Bad Request` error when the equity breakdown cannot be computed due to either the model portfolio having no composition or the latest composition being empty. 
     * Get equity breakdown for a model portfolio that only includes instruments with a MIFIR code of \"SHRS\"
     */
    async getModelPortfolioEquityBreakdownRaw(requestParameters: GetModelPortfolioEquityBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationBreakdown>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling getModelPortfolioEquityBreakdown.');
        }

        if (requestParameters.modelPortfolioId === null || requestParameters.modelPortfolioId === undefined) {
            throw new runtime.RequiredError('modelPortfolioId','Required parameter requestParameters.modelPortfolioId was null or undefined when calling getModelPortfolioEquityBreakdown.');
        }

        const queryParameters: any = {};

        if (requestParameters.newBreakdown !== undefined) {
            queryParameters['newBreakdown'] = requestParameters.newBreakdown;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/habitats/{habitatId}/modelPortfolios/{modelPortfolioId}/equityBreakdown`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))).replace(`{${"modelPortfolioId"}}`, encodeURIComponent(String(requestParameters.modelPortfolioId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationBreakdownFromJSON(jsonValue));
    }

    /**
     * Returns the breakdown of the model portfolio in terms of the organizations that issued the underlying shares. The top level \'readTime\' represents the time this computation was made, the \'validAt\'s within the \'basedOn\' section represent the valid time for the compositions of the isins they\'re paired with. The endpoint will return a `400 Bad Request` error when the equity breakdown cannot be computed due to either the model portfolio having no composition or the latest composition being empty. 
     * Get equity breakdown for a model portfolio that only includes instruments with a MIFIR code of \"SHRS\"
     */
    async getModelPortfolioEquityBreakdown(requestParameters: GetModelPortfolioEquityBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationBreakdown> {
        const response = await this.getModelPortfolioEquityBreakdownRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the breakdown of the model portfolio in terms of the organizations that issued the underlying stocks, shares and bonds. The top level \'readTime\' represents the time this computation was made, the \'validAt\'s within the \'basedOn\' section represent the valid time for the compositions of the isins they\'re paired with.
     * Get organization breakdown for a model portfolio
     */
    async getOrganizationBreakdownByModelPortfolioRaw(requestParameters: GetOrganizationBreakdownByModelPortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationBreakdown>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling getOrganizationBreakdownByModelPortfolio.');
        }

        if (requestParameters.modelPortfolioId === null || requestParameters.modelPortfolioId === undefined) {
            throw new runtime.RequiredError('modelPortfolioId','Required parameter requestParameters.modelPortfolioId was null or undefined when calling getOrganizationBreakdownByModelPortfolio.');
        }

        const queryParameters: any = {};

        if (requestParameters.newBreakdown !== undefined) {
            queryParameters['newBreakdown'] = requestParameters.newBreakdown;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/habitats/{habitatId}/modelPortfolios/{modelPortfolioId}/organizationBreakdown`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))).replace(`{${"modelPortfolioId"}}`, encodeURIComponent(String(requestParameters.modelPortfolioId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationBreakdownFromJSON(jsonValue));
    }

    /**
     * Returns the breakdown of the model portfolio in terms of the organizations that issued the underlying stocks, shares and bonds. The top level \'readTime\' represents the time this computation was made, the \'validAt\'s within the \'basedOn\' section represent the valid time for the compositions of the isins they\'re paired with.
     * Get organization breakdown for a model portfolio
     */
    async getOrganizationBreakdownByModelPortfolio(requestParameters: GetOrganizationBreakdownByModelPortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationBreakdown> {
        const response = await this.getOrganizationBreakdownByModelPortfolioRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all model portfolio compositions in chronological order. The composition with the latest `validAt` time is listed first. For compositions with the same `validAt` times, the one with the latest `createdAt` time is listed first. Without any pagination parameters, a maximum of 50 compositions will be returned.
     * List model portfolio compositions
     */
    async listModelPortfolioCompositionsRaw(requestParameters: ListModelPortfolioCompositionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListModelPortfolioCompositionsResponse>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling listModelPortfolioCompositions.');
        }

        if (requestParameters.modelPortfolioId === null || requestParameters.modelPortfolioId === undefined) {
            throw new runtime.RequiredError('modelPortfolioId','Required parameter requestParameters.modelPortfolioId was null or undefined when calling listModelPortfolioCompositions.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.nextPageToken !== undefined) {
            queryParameters['nextPageToken'] = requestParameters.nextPageToken;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/habitats/{habitatId}/modelPortfolios/{modelPortfolioId}/compositions`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))).replace(`{${"modelPortfolioId"}}`, encodeURIComponent(String(requestParameters.modelPortfolioId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListModelPortfolioCompositionsResponseFromJSON(jsonValue));
    }

    /**
     * List all model portfolio compositions in chronological order. The composition with the latest `validAt` time is listed first. For compositions with the same `validAt` times, the one with the latest `createdAt` time is listed first. Without any pagination parameters, a maximum of 50 compositions will be returned.
     * List model portfolio compositions
     */
    async listModelPortfolioCompositions(requestParameters: ListModelPortfolioCompositionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListModelPortfolioCompositionsResponse> {
        const response = await this.listModelPortfolioCompositionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the model portfolios that are associated with this habitat.
     * List model portfolios
     */
    async listModelPortfoliosRaw(requestParameters: ListModelPortfoliosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListModelPortfoliosResponse>> {
        if (requestParameters.habitatId === null || requestParameters.habitatId === undefined) {
            throw new runtime.RequiredError('habitatId','Required parameter requestParameters.habitatId was null or undefined when calling listModelPortfolios.');
        }

        const queryParameters: any = {};

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.nextPageToken !== undefined) {
            queryParameters['nextPageToken'] = requestParameters.nextPageToken;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/habitats/{habitatId}/modelPortfolios`.replace(`{${"habitatId"}}`, encodeURIComponent(String(requestParameters.habitatId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListModelPortfoliosResponseFromJSON(jsonValue));
    }

    /**
     * Returns the model portfolios that are associated with this habitat.
     * List model portfolios
     */
    async listModelPortfolios(requestParameters: ListModelPortfoliosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListModelPortfoliosResponse> {
        const response = await this.listModelPortfoliosRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
